import { Button } from '@/components/ui';
import { SearchIcon } from 'lucide-react';
import React from 'react';
import { SearchDialog } from './components';
import { setSearchPopup } from '@/redux/actions/common.action';
import { AppDispatch } from '@/redux/store';
import { useDispatch } from 'react-redux';

export default function SearchBar() {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <div aria-label='Event Search' className='text-xs font-semibold'>
      <Button
        aria-label='Event Search'
        className='hover:text-primary h-9 w-9 rounded-lg border border-zinc-800 text-white'
        size={'lg'}
        variant='ghost'
        onClick={()=>dispatch(setSearchPopup(true))}
      >
        <SearchIcon className='text-primary rounded-lg' size={24} strokeWidth={3} />
      </Button>
      <SearchDialog/>
    </div>
  );
}
